import { useEffect, useState } from "react";

import MultiSelectDropdown from "../multiSelect.dropdown";
import { TICKET_STATUSES } from "../../../constants/tickets/statuses";

const CLASSNAMES = {
  multiSelectDropdown: {
    dropdownButton: {
      dropdown:
        "border-animate rounded h-[250px] w-[250px] overflow-y-scroll absolute backdrop-blur-sm bg-greenGlass flex flex-col gap-1 p-2 top-11 z-50",
    },
  },
};

const TicketStatusPresetDropdown = ({
  formFields = {},
  setFormFields = () => {},
}) => {
  const [statuses, setStatuses] = useState(
    TICKET_STATUSES.map((status) => ({
      ...status,
      show: formFields.statuses?.includes(status.id) ? true : false,
    }))
  );
  const [search, setSearch] = useState("");

  const handleChange = (event) => {
    const { name } = event.target;
    setStatuses([
      ...statuses.map((status) =>
        status.id === name ? { ...status, show: !status.show } : status
      ),
    ]);
  };
  useEffect(() => {
    if (statuses.length) {
      setFormFields({
        ...formFields,
        statuses: statuses
          .filter((status) => status.show)
          .map((status) => status.id),
      });
    }
  }, [statuses]);

  const handleSearch = (event) => {
    const { value } = event.target;
    setSearch(value);
  };
  return (
    <MultiSelectDropdown
      classNames={CLASSNAMES.multiSelectDropdown}
      label="Statuses"
      options={statuses.filter((status) => {
        if (search === "") return status;
        return status.name?.toLowerCase().includes(search.toLowerCase());
      })}
      handleChange={handleChange}
      search={{
        enabled: true,
        placeholder: "Search...",
        handleSearch,
      }}
    />
  );
};

export default TicketStatusPresetDropdown;
